export const fontFamily = {
    heading: "'Frank Ruhl Libre', serif",
    body: "'Poppins', sans-serif",
    manrope: " 'Manrope', sans-serif",
    Inter: "'Inter', sans-serif;"
}